var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#002cfa;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1617 -2529.633)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1618.784 2530.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.046,11.106a3.008,3.008,0,0,0-2.421,1.223L21.9,9.914a3.01,3.01,0,0,0-.1-1.978L26.754,4.96a3,3,0,1,0-.515-.861L21.274,7.082a3.01,3.01,0,1,0,.185,3.734l4.712,2.408a3.011,3.011,0,1,0,2.875-2.118Zm0-10.1a2.007,2.007,0,1,1-2.007,2.007A2.009,2.009,0,0,1,29.046,1ZM19.011,11.072a2.007,2.007,0,1,1,2.007-2.007A2.009,2.009,0,0,1,19.011,11.072Zm10.035,5.051a2.007,2.007,0,1,1,2.007-2.007A2.009,2.009,0,0,1,29.046,16.123Z",
    transform: "translate(-16)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 20,
    height: 20,
    transform: "translate(1617 2529.633)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMobile);
export default __webpack_public_path__ + "static/media/share-mobile.3c4888fb8bf72167a99cfe3671c735e3.svg";
export { ForwardRef as ReactComponent };